<template>
  <!-- Show policy review card if there are policy issues -->
  <v-card
    v-if="shouldShowCard"
    class="mt-4"
    color="surface"
    variant="elevated"
    elevation="0"
    style="border: 2px solid #eb3d52">
    <v-card-title class="text-h6">
      <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
      Policy Compliance Alert
      <v-chip v-if="outcomePrediction" class="ml-3" color="error" text-color="white" small>
        Likely to be Denied
      </v-chip>
    </v-card-title>
    <v-card-text>
      <div class="text-body-1 font-weight-semibold mb-3">Summary:</div>
      <ul class="pl-4">
        <li v-for="(item, index) in order.policyReview.summary" :key="index" class="text-body-2 mb-2">
          {{ item }}
        </li>
      </ul>
    </v-card-text>
  </v-card>

  <!-- Show checklist policy issues banner -->
  <v-alert v-if="policyIssueCount > 0" type="error" variant="tonal" class="mt-4" prominent>
    <template #prepend>
      <v-icon color="error">mdi-alert-circle</v-icon>
    </template>
    <div class="d-flex align-center justify-space-between">
      <div>
        <div class="text-subtitle-1 font-weight-bold">Policy Compliance Issue Detected</div>
        <div class="text-body-2">
          {{ policyIssueCount }} answer{{ policyIssueCount > 1 ? "s do" : " does" }} not align with the payer's coverage
          criteria. Review the flagged questions below before submitting.
        </div>
      </div>
    </div>
  </v-alert>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  order: {
    type: Object,
    required: true,
  },
});

const order = ref(props.order);

const outcomePrediction = computed(() => {
  return order.value.policyReview?.outcomePrediction || null;
});

const shouldShowCard = computed(() => {
  return (
    order.value.policyReview &&
    order.value.policyReview.summary &&
    order.value.policyReview.summary.length &&
    (outcomePrediction.value === "DENY" || outcomePrediction.value === "MIXED")
  );
});

const policyIssueCount = computed(() => {
  const reviews = order.value.checklistPolicyReviews || [];
  return reviews.filter((r) => r.alignsWithPolicy === "NO").length;
});
</script>
